import script from "./AssinarPublico.vue?vue&type=script&setup=true&lang=js"
export * from "./AssinarPublico.vue?vue&type=script&setup=true&lang=js"

import "./AssinarPublico.vue?vue&type=style&index=0&id=a7a60f50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a60f50"]])

export default __exports__